export function capitalize (value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function implode (arr: string[]) {
  return arr.join(', ')
}

export function excerpt (text: string, limit: number) {
  return text.length > limit ? `${text.substring(0, limit)}...` : text
}

export function addSpaces (text: string) {
  return text.replace(/([A-Z])/g, ' $1').trim()
}

export function addSpacesAndLowerCase (text: string) {
  return addSpaces(text).toLowerCase()
}

export function addSpacesAndCapitalize (text: string) {
  return capitalize(addSpaces(text).toLowerCase())
}

export function getIndefiniteArticle (text: string) {
  return ['a', 'e', 'i', 'o'].includes(text[0].toLowerCase()) ? 'an' : 'a'
}
